import { memo } from 'react'
import { Button } from '@cargomart/ui'
import { useMockOrderCreate } from 'hooks/useMockOrderCreate'

export const MockOrderData = () => {
  const { setMockData, isCanMock } = useMockOrderCreate()

  if (!isCanMock) {
    return <></>
  }

  return (
    <Button className="!fixed left-0 top-0" onClick={setMockData} type="button">
      тестовые данные
    </Button>
  )
}
export default memo(MockOrderData)
